import { baseConfig } from '../baseConfig';

/**
 * Get image URL from image key.
 * @function getTransformationUrl
 * @param {string} imageKey - imageKey.
 * @param {string} location - location.
 * @param {string} browser - browser.
 * @param {number} version - version.
 * @return {string} image URL.
 */

// thumbnail desktop v2 -- for productboxes
// just the imagekey -- works for the rest (full size)

export const getTransformationUrl = (
    imageKey = 'default',
    location: 'pdp' | 'cart' | 'thumbnail' = 'pdp',
    browser: 'desktop' | 'mobile' = 'desktop',
    version: 1 | 2 = 1,
): string => {
    const transformationType = `${browser}-${location}-v${version}`;
    return `${baseConfig.urls.productImageBase}/t_${transformationType}/${imageKey}.jpg`;
};
